import baseApi from './RootBaseApi';
import {
  EnvironmentVariable,
  EnvironmentVariablesParams,
  EnvironmentVariablesResponse,
  ExternalServiceType,
} from '@/types/environment-variables.types';

export const EnvironmentVariablesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEnvironmentVariables: builder.query<
      EnvironmentVariablesResponse,
      EnvironmentVariablesParams
    >({
      query: (params) => ({
        url: '/external-services',
        method: 'GET',
        params,
      }),
      providesTags: ['PlatformSettings'],
    }),
    getEnvironmentVariableById: builder.query<EnvironmentVariable, string>({
      query: (id) => ({
        // TODO: Replace with the final API endpoint for fetching a single environment variable
        url: `/external-services/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: EnvironmentVariable }) =>
        response.data,
      providesTags: ['PlatformSettings'],
    }),
    getEnvironmentVariableByServiceType: builder.query<
      EnvironmentVariable,
      ExternalServiceType
    >({
      query: (serviceType) => ({
        url: `/external-services/service-type/${serviceType}`,
        method: 'GET',
      }),
      transformResponse: (response: { data: EnvironmentVariable }) =>
        response.data,
      providesTags: ['PlatformSettings'],
    }),
    updateEnvironmentVariable: builder.mutation<
      void,
      { id: string; data: { secret_key?: string; mode_type?: number } }
    >({
      query: ({ id, data }) => ({
        // TODO: Replace with the final API endpoint for updating an environment variable
        url: `/external-services/${id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: ['PlatformSettings'],
    }),
    getPaymentOptions: builder.query<EnvironmentVariable[], void>({
      query: () => ({
        url: '/external-services/payment-options',
        method: 'GET',
      }),
      transformResponse: (response: { data: EnvironmentVariable[] }) =>
        response.data,
    }),
  }),
});

export const {
  useGetEnvironmentVariablesQuery,
  useGetEnvironmentVariableByIdQuery,
  useGetEnvironmentVariableByServiceTypeQuery,
  useUpdateEnvironmentVariableMutation,
  useGetPaymentOptionsQuery,
} = EnvironmentVariablesService;
